export const SESSION_TOKEN = "ORDER_TOKEN";
